import * as t from "io-ts";

export const DashboardCodec = t.strict({
    live: t.number,
    draft: t.number,
    archived: t.number,
    issues: t.number
});

export type ResponseDashboard = t.OutputOf<typeof DashboardCodec>;